<template>
  <div class="container mt-xs-7 mt-sm-3 mt-md-2 mt-lg-1 mt-xl-1">
    <t-theme-essay :themeId="themeId" v-if="loaded"></t-theme-essay>
    <div class="columns">
      <div class="column is-two-thirds">
        <span class="content" id="span_essay">
          <canvas width="790" height="1000" id="essay"></canvas>
        </span>
        <div>
          <v-textarea
            label="Considerações finais"
            outlined
            placeholder="Escreva..."
            v-model="comment"></v-textarea>
        </div>
      </div>
      <div class="column">
        <v-card>
          <v-tabs
            v-model="tab"
            background-color="primary"
            dark
          >
            <v-tab>
              Marcações
            </v-tab>
            <v-tab>
              Notas
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row cols="12" :key="index" v-for="(skill, index) in skills">
                    <v-radio-group v-model="skillSelected">
                      <v-radio
                        :id="`${index}`"
                        :value="skill.id"
                        :style="{
                          backgroundColor: skill.color,
                          padding: '5px',
                          borderRadius: '10px'
                        }"
                        @click="selectSkill(skill.id)"
                      >
                        <template v-slot:label>
                          <strong class="white--text">{{skill.name}}</strong>
                        </template>
                      </v-radio>
                    </v-radio-group>

                    <v-col sm="12" v-if="skill.id == skillSelected">
                      <div class="column">
                        <v-textarea outlined placeholder="Comentários aqui" v-model="note"></v-textarea>
                      </div>
                      <div class="column">
                        <t-button @click="highlight(skill)">Salvar marcação</t-button>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-if="corrections.length > 0">
                  <v-list-item-title class="headline mb-1">Comentários</v-list-item-title>
                  <v-card
                    class="mx-auto"
                    max-width="344"
                    outlined
                    :key="correct.uuid"
                    :color="correct.skill.color"
                    v-for="correct in corrections"
                  >
                    <v-card-title
                      class="white--text"
                      v-text="`${correct.counter} - ${correct.skill.name}`"
                    ></v-card-title>

                    <v-card-text>
                      <div class="headline white--text">
                        {{correct.comment}}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row cols="12" :key="index" v-for="(skill, index) in skills">
                    <v-col sm="8" md="8" xs="4">
                      <div
                        class="white--text"
                        :style="{
                          backgroundColor: skill.color,
                          padding: '5px',
                          borderRadius: '10px'
                        }">
                        {{skill.name}}
                      </div>
                    </v-col>
                    <v-col sm="4" md="4" xs="4">
                      <v-text-field
                        name="nota"
                        label="Nota"
                        type="text"
                        placeholder="Digite a nota"
                        outlined
                        single-line
                        v-model="grade[index]"
                        error-messages="A nota obrigatório"
                        v-if="skill.grades.length === 1"
                      />
                      <v-select
                        dense
                        :items="skill.grades"
                        v-model="grade[index]"
                        item-text="value"
                        item-value="value"
                        label="Nota"
                        outlined
                        v-if="skill.grades.length > 1"
                      ></v-select>
                    </v-col>
                  </v-row>
                    <div class="column">
                      <t-button @click="finishCorrection()">Finalizar correção</t-button>
                    </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import TThemeEssay from '@/components/TThemeEssay.vue'
import SkillService from '@/services/skill/skill'
import EssayService from '@/services/essay/essay'
import notification from '@/support/mixins/notifications.mixin'
import { v4 as uuidv4 } from 'uuid'
import ManipulateCanvas from '@/support/manipulate-canvas'
import localforage from 'localforage'
export default {
  name: 'Reviewer',
  components: {
    TThemeEssay
  },
  mixins: [notification],
  data: () => ({
    SkillService: new SkillService(),
    EssayService: new EssayService(),
    comment: '',
    essay: {},
    tab: null,
    note: '',
    skills: [],
    stage: {},
    grade: [],
    marker: {},
    marcacao: true,
    showSkills: false,
    showGrade: false,
    skillSelected: '',
    moveListener: {},
    selection: {},
    strokeDash: {},
    rect: {},
    text: {},
    rectFinalized: {},
    graph: {},
    count: 1,
    container: {},
    layoutWidth: 0,
    layoutHeight: 0,
    containerWidth: 0,
    containerHeight: 0,
    corrections: [],
    themeId: null,
    loaded: false
  }),
  async mounted () {
    try {
      this.essay = await localforage.getItem('essay')
      this.skills = this.essay.theme.institution.skills
      this.stage = new createjs.Stage('essay')
      this.loadImage(this.essay.download)
    } catch (error) {
      this.stage = new createjs.Stage('essay')
      this.getEssay()
    }
    this.themeId = this.essay.theme_id
    this.loadInfoToStage()
    this.addArrow()
  },
  methods: {
    dataURItoBlob (dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    async print () {
      const essay = document.querySelector('#essay')
      const image = ManipulateCanvas.fromCanvas(essay).toBase64()
      return this.dataURItoBlob(image)
    },
    async finishCorrection () {
      if (this.grade.length < this.skills.length) {
        this.errorMsg(
          'Notas',
          'Para finalizar a correção é necessário preencher todas as notas',
          'topCenter'
        )
        return
      }
      if (this.comment === '') {
        this.errorMsg(
          'Considerações finais',
          'É necessário preencher o campo considerações finais',
          'topCenter'
        )
        return
      }
      try {
        const print = await this.print()
        const gradePerSkill = this.skills.map((skill, index) => ({
          grade: this.grade[index],
          skill
        }))
        const formData = new FormData()
        this.corrections.forEach(correction => {
          delete correction.uuid
          delete correction.skill
          formData.append('corrections[]', JSON.stringify(correction))
        })
        formData.append('grades_per_skill', JSON.stringify(gradePerSkill))
        formData.append('file', print)
        formData.append('comment', this.comment)
        await this.EssayService.sendCorrection(this.essay.id, formData)
        this.successMsg('Redação', 'Redação corrigida com sucesso', 'topCenter')
        await localforage.clear()
        this.$router.push({ name: 'Redações' })
      } catch (error) {
        this.errorMsg('Redação', error.message, 'topCenter')
      }
    },
    async getEssay () {
      try {
        const { data } = await this.EssayService.get(this.$route.params.id)
        this.essay = {
          ...data.essay,
          download: data.download
        }
        this.skills = this.essay.theme.institution.skills
        try {
          this.essay.dateInit = new Date().getTime()
          const value = await localforage.setItem('essay', this.essay)
          console.log(value)
          console.log(this.essay)
        } catch (error) {
          console.log(error)
        }
        this.themeId = this.essay.theme_id
        this.loadImage(this.essay.download)
      } catch (error) {
        console.log(error)
      } finally {
        this.loaded = true
      }
    },
    async highlight (skill) {
      this.graph.clear()
        .setStrokeStyle(1).beginStroke('#000')
        .setStrokeDash([10, 5], 0).beginFill(`${skill.color}59`)
        .drawRect(0, 0, this.rect.w, this.rect.h)
      const correcao = {
        counter: this.count === 1 ? this.count : this.count - 1,
        uuid: uuidv4(),
        comment: this.note,
        skill,
        skill_id: skill.id,
        essay_id: this.essay.id,
        graph: this.graph,
        rectWidth: this.rect.w,
        rectHeight: this.rect.h,
        rectX: this.container.children[0].x,
        rectY: this.container.children[0].y,
        textX: this.container.children[1].x,
        textY: this.container.children[1].y
      }
      this.corrections.push(correcao)
      this.note = ''
      this.skillSelected = ''
      try {
        const value = await localforage.setItem('review', this.corrections)
        console.log(value)
      } catch (error) {
        console.log(error)
      }
      this.addArrow()
    },
    async loadInfoToStage () {
      try {
        const corrections = await localforage.getItem('review')
        if (corrections) {
          this.corrections = corrections
          this.count = corrections[corrections.length - 1].counter
          corrections.forEach(correction => {
            this.retrieveRectangle(correction)
          })
          this.count++
          return
        }
      } catch (error) {
        console.log(error)
        this.initNewRectangle()
      }
    },
    loadImage (imageUrl) {
      const imageobj = new Image()
      const image = new createjs.Bitmap(imageobj)
      imageobj.crossOrigin = 'anonymous'
      imageobj.src = imageUrl
      imageobj.onload = () => {
        const w = this.stage.canvas.width
        const h = this.stage.canvas.height
        const xratio = w / imageobj.width
        const yratio = h / imageobj.height
        const scale = Math.min(xratio, yratio)
        image.scaleX = image.scaleY = scale
        image.x = (w - imageobj.width * scale) / 2
        image.y = (h - imageobj.height * scale) / 2
        this.stage.addChild(image)
        this.stage.update()
      }
    },
    openSkills () {
      this.showSkills = !this.showSkills
      this.showGrade = false
    },
    openGrade () {
      this.showGrade = !this.showGrade
      this.showSkills = false
    },
    addArrow () {
      createjs.Ticker.on('tick', this.tick)
      this.initNewRectangle()
      this.stage.on('stagemousedown', this.dragStart)
      this.stage.on('stagemouseup', this.dragEnd)
    },
    dragStart (event) {
      this.initNewRectangle()
      this.container.addChild(this.selection).set({ x: event.stageX, y: event.stageY })
      this.container.addChild(this.text)
      this.stage.addChild(this.container)
      this.rect.w = 0
      this.rect.h = 0
      this.moveListener = this.stage.on('stagemousemove', this.drag)
    },
    drag (event) {
      this.rect.w = event.stageX - this.selection.x
      this.rect.h = event.stageY - this.selection.y
      this.text.x = event.stageX - this.rect.w / 2
      this.text.y = event.stageY - this.rect.h / 2
    },
    dragEnd (event) {
      this.count++
      this.stage.off('stagemousemove', this.moveListener)
      this.stage.removeAllEventListeners()
    },
    tick (event) {
      this.stage.update(event)
      this.strokeDash.offset--
    },
    initNewRectangle () {
      this.selection = new createjs.Shape()
      this.graph = this.selection.graphics.setStrokeStyle(1).beginStroke('#000').beginFill('rgba(0,0,0,0.05)')
      this.strokeDash = this.graph.setStrokeDash([10, 5], 0).command
      this.rect = this.graph.drawRect(0, 0, 100, 100).command
      this.text = new createjs.Text(this.count, '30px Arial Bold', '#000')
      this.text.textAlign = 'center'
      this.text.textBaseline = 'middle'
      this.container = new createjs.Container()
    },
    retrieveRectangle (correction) {
      this.selection = new createjs.Shape()
      this.graph = this.selection.graphics.setStrokeStyle(1).beginStroke('#000').beginFill('rgba(0,0,0,0.05)')
      this.graph.clear()
        .setStrokeStyle(1).beginStroke('#000')
        .setStrokeDash([10, 5], 0).beginFill(`${correction.skill.color}59`)
        .drawRect(correction.rectX, correction.rectY, correction.rectWidth, correction.rectHeight)
      this.strokeDash = this.graph.setStrokeDash([10, 5], 0).command
      this.text = new createjs.Text(correction.counter, '40px Arial Bold', '#000')
      this.text.textAlign = 'center'
      this.text.textBaseline = 'middle'
      this.container = new createjs.Container()
      this.container.addChild(this.selection)
      this.container.addChild(this.text).set({ x: correction.textX, y: correction.textY })
      this.stage.addChild(this.container)
      this.stage.update()
    },
    selectSkill (id) {
      this.skillSelected = id
    }
  }
}
</script>

<style scoped>
/* .column {
  border: 1px solid;
} */
.fa-2x {
  font-size: 1.5em;
}
.action {
  cursor: pointer;
  padding-right: 5px;
}
.div-p {
  background-color: #e0e9f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.tools-div {
  margin-top: 1rem;
  margin-bottom: 1rem !important;
}
.markerjs-toolbar {
  position: absolute !important;
  left: 0 !important;
  top: 164.333px !important;
  right: 530px !important;
}
.pb-10 {
  padding-bottom: 10px;
}
.grade-container {
  border-bottom: 1px solid #9edbdf;
  border-right: 1px solid #9edbdf;
  border-left: 1px solid #9edbdf;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.grade {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.v-messages {
  min-height: 0px !important;
}
</style>
